import $ from 'jquery'
const jQuery = $;

(function ($) {

    $.fn.dpMenu = function (opts) {
        this.each(function () {
            init.call(this, opts);
        });

        return this;
    };

    function init(opts) {
        let $menu = $(this),
            activeRow = null,
            mouseLocs = [],
            lastDelayLoc = null,
            timeoutId = null,
            options = $.extend({
                rowSelector: '> li',
                submenuSelector: '*',
                submenuDirection: 'right',
                tolerance: 75,
                enter: $.noop,
                exit: $.noop,
                activate: $.noop,
                deactivate: $.noop
            }, opts);

        let MOUSE_LOCS_TRACKED = 3, // 记录鼠标位置
            DELAY = 100; // ms 当用户有趋势去二级导航就延时300

        /**
         * 记录鼠标移动位置
         * @param {*} e 
         */
        let mousemoveDocument = function (e) {
            mouseLocs.push({ x: e.pageX, y: e.pageY });

            if (mouseLocs.length > MOUSE_LOCS_TRACKED) {
                mouseLocs.shift();
            }
        };

        /**
         * 当鼠标离开时，清除定时器和active条目
         */
        let mouseleaveMenu = function () {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }

            if (activeRow) {
                options.deactivate(activeRow);
            }

            activeRow = null;

        };

        let mouseenterRow = function () {
            if (timeoutId) {
                // 清除前面的定时器
                clearTimeout(timeoutId);
            }

            options.enter(this);
            possiblyActivate(this);
        };
            
        let mouseleaveRow = function () {
                options.exit(this);
            };


        let clickRow = function () {
            activate(this);
        };


        let activate = function (row) {
            if (row == activeRow) {
                return;
            }

            if (activeRow) {
                options.deactivate(activeRow);
            }

            options.activate(row);
            activeRow = row;
        };

        /**
         * 用户可能active的条目
         * @param {*} row 
         */
        let possiblyActivate = function (row) {
            let delay = activationDelay();

            if (delay) {
                timeoutId = setTimeout(function () {
                    possiblyActivate(row);
                }, delay);
            } else {
                activate(row);
            }
        };


        let activationDelay = function () {
            if (!activeRow || !$(activeRow).is(options.submenuSelector)) {
                // 如果没有二级导航被激活，则立即返回
                return 0;
            }

            let offset = $menu.offset(),
                upperLeft = {
                    x: offset.left,
                    y: offset.top - options.tolerance
                },
                upperRight = {
                    x: offset.left + $menu.outerWidth(),
                    y: upperLeft.y
                },
                lowerLeft = {
                    x: offset.left,
                    y: offset.top + $menu.outerHeight() + options.tolerance
                },
                lowerRight = {
                    x: offset.left + $menu.outerWidth(),
                    y: lowerLeft.y
                },
                loc = mouseLocs[mouseLocs.length - 1],
                prevLoc = mouseLocs[0];

            if (!loc) {
                return 0;
            }

            if (!prevLoc) {
                prevLoc = loc;
            }

            if (prevLoc.x < offset.left || prevLoc.x > lowerRight.x ||
                prevLoc.y < offset.top || prevLoc.y > lowerRight.y) {
                // 如果鼠标移出导航栏，立即返回
                return 0;
            }

            if (lastDelayLoc &&
                loc.x == lastDelayLoc.x && loc.y == lastDelayLoc.y) {
                // 如果鼠标不动，也立即返回
                return 0;
            }

            /**
             * 计算a,b 两点的斜率
             * @param {*} a 
             * @param {*} b 
             */
            function slope(a, b) {
                return (b.y - a.y) / (b.x - a.x);
            }

            let decreasingCorner = upperRight,
                increasingCorner = lowerRight;


            if (options.submenuDirection == 'left') {
                decreasingCorner = lowerLeft;
                increasingCorner = upperLeft;
            } else if (options.submenuDirection == 'below') {
                decreasingCorner = lowerRight;
                increasingCorner = lowerLeft;
            } else if (options.submenuDirection == 'above') {
                decreasingCorner = upperLeft;
                increasingCorner = upperRight;
            }

            let decreasingSlope = slope(loc, decreasingCorner),
                increasingSlope = slope(loc, increasingCorner),
                prevDecreasingSlope = slope(prevLoc, decreasingCorner),
                prevIncreasingSlope = slope(prevLoc, increasingCorner);

            if (decreasingSlope < prevDecreasingSlope &&
                increasingSlope > prevIncreasingSlope) {

                lastDelayLoc = loc;
                return DELAY;
            }

            lastDelayLoc = null;
            return 0;
        };


        $menu
            .mouseleave(mouseleaveMenu)
            .find(options.rowSelector)
            .mouseenter(mouseenterRow)
            .mouseleave(mouseleaveRow)
            .click(clickRow);

        $menu.mousemove(mousemoveDocument);

    }
})(jQuery);




// WEBPACK FOOTER //
// ./modules/cate-nav-index/js/dpMenu.js